<template>
  <router-link
    v-if="creator?.lan_party_uuid"
    :to="{ name: 'LanControlRoomPage', params: { slug: creator.slug } }"
    class="inline-flex items-center flex-shrink-0 gap-2 rounded-lg font-bold tracking-wide transition-colors hover:brightness-125"
    :class="compact ? 'h-8 px-2.5 text-xs' : 'h-10 px-3 text-sm'"
    style="background:#EF444420;color:#EF6B6B"
  >
    <span class="w-2 h-2 rounded-full bg-red-500" aria-hidden="true" />
    {{ $t('play.lan_party.on_pill') }}
  </router-link>
  <router-link
    v-else-if="lan && !isQueued && !activeLobby"
    :to="{ name: 'LanPartyPage', params: { slug: lan.creator } }"
    class="inline-flex items-center flex-shrink-0 gap-2 rounded-lg ring-1 ring-secondary-800 bg-secondary-950 font-semibold text-secondary-200 transition-colors hover:brightness-125"
    :class="compact ? 'h-8 px-2.5 text-xs' : 'h-10 px-3 text-sm'"
  >
    <span class="w-2 h-2 rounded-full bg-secondary-400" aria-hidden="true" />
    {{ $t('play.lan_party.member_pill', { name: lan.creator_name }) }}
  </router-link>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useQueueSearch } from '../../composables/useMatchmakingQueue';

defineProps({
  compact: { type: Boolean, default: false },
});

const store = useStore();
const { isQueued, activeLobby } = useQueueSearch();
// Managers with a night open: back to the control room.
const creator = computed(() => store.getters.matchmakingContext?.creator);
// Viewers in a night but not queueing: the way back to it, as the sidebar has no LAN entry.
const lan = computed(() => store.getters.matchmakingContext?.lan_party);
</script>
